export default __webpack_public_path__ + "static/media/astroImg.281919da.jpeg";